import React, { useRef } from "react";
import "./InvoiceGenerator.css";
import "bootstrap/dist/css/bootstrap.min.css";
import html2pdf from "html2pdf.js";

const InvoiceGenerator = () => {
  const invoiceRef = useRef();

  let DATE = "15-04-2026";

  const handleDownloadPDF = () => {
    const element = invoiceRef.current;
    const opt = {
      margin: 0.5,
      filename: `${DATE}invoice.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    html2pdf().set(opt).from(element).save();
  };

  return (
    <div
      className="invoice-wrapper"
      style={{ backgroundColor: "#fff", color: "#000" }}
    >
      <div className="text-end mb-3">
        <button className="btn btn-primary" onClick={handleDownloadPDF}>
          Download PDF
        </button>
      </div>

      <div
        ref={invoiceRef}
        className="invoice-container container p-4 shadow rounded"
        style={{ backgroundColor: "#fff", color: "#000" }}
      >
        <h4 className="text-center fw-bold mb-4" style={{ color: "#000" }}>
          INVOICE
        </h4>

        <div className="row">
          {/* Company Info */}
          <div className="col-md-6">
            <h5 className="fw-bold" style={{ color: "#000" }}>
              JAIPAL CHOUHAN
            </h5>
            <p className="mb-0" style={{ color: "#000" }}>
              Plot no. 191 A Ashok vihar, jagatpura , jaipur , 302017
            </p>
            {/* <p className="mb-0">THIKRIA, AJMER ROAD, JAIPUR, 302026</p> */}
            <p className="mb-0" style={{ color: "#000" }}>
              Mail: jaipalrajput9680@gmail.com
            </p>
          </div>

          {/* Invoice Info */}
          <div className="col-md-6 text-md-end mt-4 mt-md-0">
            <p className="mb-1" style={{ color: "#000" }}>
              <strong>Invoice for</strong>
            </p>
            <p className="mb-1" style={{ color: "#000" }}>
              Tanmay Sharma
            </p>

            {/* <p className="mb-1"></p> */}
            <p className="mb-1" style={{ color: "#000" }}>
              PLOT NO. - 4 JANAK PURI SODALA JAIPUR RAJASTHAN 302019
            </p>

            <p className="mb-1" style={{ color: "#000" }}>
              <strong style={{ color: "#000" }}>Date:</strong> {DATE}
            </p>
          </div>

          {/* <div className="col-md-6 text-md-end mt-4 mt-md-0">
            <p className="mb-1">
              <strong>Invoice for</strong>
            </p>
            <p className="mb-1">PAYTM BUSINESS DESIRE11</p>

            <p className="mb-1">
              <strong>Date:</strong> {DATE}
            </p>
          </div> */}

          {/* <div className="col-md-6 text-md-end mt-4 mt-md-0">
            <p className="mb-1">
              <strong>Invoice for</strong>
            </p>
            <p className="mb-1">AMISHA SAINI</p>
            <p className="mb-1">F - 5 NANDPURI 22 GODAM</p>
            <p className="mb-1">SODALA JAIPUR RAJASTHAN 302019</p>
            <p className="mb-1">
              <strong>Date:</strong> {DATE}
            </p>
          </div> */}
        </div>

        <hr className="my-4" style={{ color: "#000" }} />

        {/* Table */}
        <table className="table table-bordered text-center mb-5">
          <thead className="table-light">
            <tr>
              <th style={{ color: "#000" }}>Particulars</th>
              <th style={{ color: "#000" }}>Total Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {/* <td>MAINTENANCE AND DEVELOPMENT SERVICES (MJ LUDO)</td> */}
              {/* <td>MAINTENANCE AND DEVELOPMENT SERVICES (JAYURE)</td> */}
              <td style={{ color: "#000" }}>
                MAINTENANCE AND DEVELOPMENT SERVICES (DEVINE11)
              </td>
              {/* <td>MAINTENANCE AND DEVELOPMENT SERVICES (CLASHY JOY)</td> */}
              {/* <td>DEVELOPMENT SERVICES (DESIRE11 LIVE SCORE APP)</td> */}
              {/* <td>CONSULTANCY SERVICES (SHOPPING APP)</td> */}
              <td style={{ color: "#000" }}>₹56,0000.00</td>
            </tr>
            <tr>
              <td style={{ color: "#000" }}>REMAINING</td>
              <td style={{ color: "#000" }}>₹00.00</td>
            </tr>
            <tr>
              <td style={{ color: "#000" }}>EXTRA WORK</td>
              <td style={{ color: "#000" }}>₹00.00</td>
            </tr>
            <tr className="fw-bold">
              <td style={{ color: "#000" }}>Total</td>
              <td style={{ color: "#000" }}>₹56,0000.00</td>
            </tr>
          </tbody>
        </table>

        <div className="d-flex justify-content-end">
          <div className="text-end">
            <p className="fw-bold mb-1" style={{ color: "#000" }}>
              Subtotal: ₹56,0000.00
            </p>
            <p className="fw-bold mb-1" style={{ color: "#000" }}>
              Total: ₹56,0000.00
            </p>
          </div>
        </div>

        <hr className="my-4" />

        {/* Bank Details */}
        <div className="row">
          <div className="col-md-8">
            <h6 className="fw-bold mb-2" style={{ color: "#000" }}>
              Bank Details
            </h6>
            <p className="mb-1" style={{ color: "#000" }}>
              <strong>Bank Name:</strong> IDFC FIRST BANK
            </p>
            <p className="mb-1" style={{ color: "#000" }}>
              <strong>A/c No:</strong> 10239311239
            </p>
            <p className="mb-1" style={{ color: "#000" }}>
              <strong>IFSC:</strong> IDFB0042124
            </p>
            <p className="mb-1" style={{ color: "#000" }}>
              JAIPUR BRANCH
            </p>
          </div>
        </div>
        <div className="text-center" style={{ color: "#000" }}>
          <p className="small text-muted mt-5">
            This is a Computer Generated Invoice
          </p>
        </div>
      </div>
    </div>
  );
};

export default InvoiceGenerator;
